import { Draft } from '@reduxjs/toolkit';

import { ICompanyData } from '../../initialState';

function createFailure(draft: Draft<ICompanyData>) {
  draft.create.config.isLoading = false;
}

export default createFailure;
